<!-- Mobile Footer - Accordion Style -->
<div class="lg:hidden bg-gray-900 py-8">
  <div class="container mx-auto px-4">
    <!-- Logo and Company Info -->
    <div class="mb-8 text-center">
      <div class="flex justify-center mb-4">
        <img src="/logos/version-white-red.webp" alt="ALLAS REPUESTOS" class="h-12 w-auto" />
      </div>
      <strong class="text-lg font-bold text-white mb-2">
        ¡Ayudamos a mover el mundo!
      </strong>
      <p class="text-gray-300 text-sm font-inter leading-relaxed">
        Somos la empresa líder en repuestos automotrices en Honduras con más de
        35 años de experiencia.
      </p>
    </div>

    <!-- Accordion Sections -->
    <div class="space-y-2">
      <!-- Shopping Section -->
      <div class="border-b border-gray-700">
        <button (click)="onToggleSection('shopping')" class="w-full flex items-center justify-between py-4 text-left">
          <span class="font-bold fs-condensed text-white text-lg">COMPRAR</span>
          @if(expandedSections['shopping']) {
          <lucide-icon [name]="chevronUpIcon"></lucide-icon>
          } @else {
          <lucide-icon [name]="chevronDownIcon"></lucide-icon>
          }
        </button>
        @if(expandedSections['shopping']) {
        <div class="pb-4">
          <ul class="space-y-2">
            @for(item of shopping; track item.name) {
            <li>
              <a [href]="item.href" [class.text-gray-500]="!item.active" [class.text-gray-300]="item.active"
                class="hover:text-white transition-colors font-inter text-sm block py-1">
                {{ item.name }}
              </a>
            </li>
            }
          </ul>
        </div>
        }
      </div>

      <!-- Categories -->
      <div class="border-b border-gray-700">
        <button (click)="onToggleSection('categories')" class="w-full flex items-center justify-between py-4 text-left">
          <span class="font-bold fs-condensed text-white text-lg">
            PRODUCTOS
          </span>
          @if(expandedSections['categories']) {
          <lucide-icon [name]="chevronUpIcon"></lucide-icon>
          } @else {
          <lucide-icon [name]="chevronDownIcon"></lucide-icon>
          }
        </button>
        @if(expandedSections['categories']) {
        <div class="pb-4">
          <ul class="space-y-2">
            @for(category of categories; track category.name) {
            <li>
              <a [href]="category.href" [class.text-gray-500]="!category.active" [class.text-gray-300]="category.active"
                class="hover:text-white transition-colors font-inter text-sm block py-1">
                {{ category.name }}
              </a>
            </li>
            }
          </ul>
        </div>
        }
      </div>

      <!-- Services -->
      <div class="border-b border-gray-700">
        <button (click)="onToggleSection('services')" class="w-full flex items-center justify-between py-4 text-left">
          <span class="font-bold fs-condensed text-white text-lg">
            SERVICIOS
          </span>
          @if(expandedSections['services']) {
          <lucide-icon [name]="chevronUpIcon"></lucide-icon>
          } @else {
          <lucide-icon [name]="chevronDownIcon"></lucide-icon>
          }
        </button>
        @if(expandedSections['services']) {
        <div class="pb-4">
          <ul class="space-y-2">
            @for(service of services; track service.name) {
            <li>
              <a [href]="service.href" [class.text-gray-500]="!service.active" [class.text-gray-300]="service.active"
                class="hover:text-white transition-colors font-inter text-sm block py-1">
                {{ service.name }}
              </a>
            </li>
            }
          </ul>
        </div>
        }
      </div>

      <!-- Customer Service -->
      <div class="border-b border-gray-700">
        <button (click)="onToggleSection('help')" class="w-full flex items-center justify-between py-4 text-left">
          <span class="font-bold fs-condensed text-white text-lg">AYUDA</span>
          @if(expandedSections['help']) {
          <lucide-icon [name]="chevronUpIcon"></lucide-icon>
          } @else {
          <lucide-icon [name]="chevronDownIcon"></lucide-icon>
          }
        </button>
        @if(expandedSections['help']) {
        <div class="pb-4">
          <ul class="space-y-2">
            @for(link of customerService; track link.name) {
            <li>
              <a [href]="link.href" [class.text-gray-500]="!link.active" [class.text-gray-300]="link.active"
                class="hover:text-white transition-colors font-inter text-sm block py-1">
                {{ link.name }}
              </a>
            </li>
            }
            <p class="text-gray-300 transition-colors font-inter text-sm">
              Horarios:
            </p>
            <p class="text-gray-300 transition-colors font-inter text-sm">
              Lun-Vie: 8:00 AM - 5:00 PM
            </p>
            <p class="text-gray-300 transition-colors font-inter text-sm">
              Sáb: 8:00 AM - 3:00 PM
            </p>
          </ul>
        </div>
        }
      </div>

      <!-- About Us -->
      <div class="border-b border-gray-700">
        <button (click)="onToggleSection('about')" class="w-full flex items-center justify-between py-4 text-left">
          <span class="font-bold fs-condensed text-white text-lg">
            ACERCA DE
          </span>
          @if(expandedSections['about']) {
          <lucide-icon [name]="chevronUpIcon"></lucide-icon>
          } @else {
          <lucide-icon [name]="chevronDownIcon"></lucide-icon>
          }
        </button>
        @if(expandedSections['about']) {
        <div class="pb-4">
          <ul class="space-y-2">
            @for(link of company; track link.name) {
            <li>
              <a [href]="link.href" [class.text-gray-500]="!link.active" [class.text-gray-300]="link.active"
                class="hover:text-white transition-colors font-inter text-sm block py-1">
                {{ link.name }}
              </a>
            </li>
            }
          </ul>
        </div>
        }
      </div>
    </div>

    <!-- Subtle Contact Information -->
    <div class="border-t border-gray-800 pt-8 pb-2">
      <div class="text-center">
        <h4 class="text-xl mb-4 text-white font-bold fs-condensed">
          CONTÁCTANOS
        </h4>

        <div class="flex flex-wrap justify-center gap-6 text-sm text-gray-200 mb-2">
          <a [href]="whatsapp.url()" class="flex items-center gap-4 justify-between w-2/3">
            <img src="/allas-icons/whatsapp-outline.svg" alt="WhatsApp" class="w-5 h-5" />
            <span class="flex-auto text-left">WhatsApp: {{ whatsapp.display }}</span>
          </a>
          <a href="tel:+50422834540" class="flex items-center gap-4 justify-between w-2/3">
            <img src="/allas-icons/phone-white.svg" alt="Phone" class="w-5 h-5" />
            <span class="flex-auto text-left">Contact Center: +504 2283-4540</span>
          </a>
          <a href="mailto:servicioalcliente@allasrepuestos.com" class="flex items-center gap-4 justify-between w-2/3">
            <img src="/allas-icons/email.svg" alt="Email" class="w-5 h-5" />
            <span class="flex-auto text-left">servicioalcliente&#64;allasrepuestos.com</span>
          </a>
          <a href="https://maps.app.goo.gl/1234567890" class="flex items-center gap-4 justify-between w-2/3">
            <img src="/allas-icons/store-new-white.svg" alt="Location" class="w-5 h-5" />
            <span class="flex-auto text-left">Honduras - Centroamérica</span>
          </a>
        </div>
      </div>
    </div>

    <!-- DOWNLOAD APP -->
    <span class="w-full flex flex-col gap-3 items-center px-8 mt-2">
      <a href="https://apps.apple.com/hn/app/allas-repuestos-bater%C3%ADas/id6752626505?l=en-GB"
        class="w-full max-w-[150px]">
        <img src="/allas-icons/app_store.svg" alt="Apple Store" class="w-full h-auto aspect-[27/8]" />
      </a>
      <a href="https://play.google.com/store/apps/details?id=com.allasrepuestos.membresia_lealtad&pcampaignid=web_share"
        class="w-full max-w-[150px]">
        <img src="/allas-icons/google-play.svg" alt="Google Play" class="w-full h-auto aspect-[27/8]" />
      </a>
      <a href="https://appgallery.huawei.com/#/app/C115506247" aria-label="Descargar aplicación desde Huawei AppGallery"
        class="w-full max-w-[150px]">
        <img src="/allas-icons/huawei-appgallery.svg" alt="Icono de Huawei AppGallery"
          class="w-full h-auto aspect-[27/8]" />
      </a>
    </span>
  </div>
</div>